import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trash",
  "use": "icon-trash-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-trash\">\n<path id=\"icon-trash_形状\" d=\"M5.6,2.9H5.5c0.1,0,0.1-0.1,0.1-0.1V2.9h4.8V2.8c0,0.1,0.1,0.1,0.1,0.1h-0.1V4h1.1V2.8c0-0.6-0.4-1-1-1h-5\n\tc-0.6,0-1,0.4-1,1V4h1.1V2.9z M13.5,4h-11C2.2,4,2,4.2,2,4.5V5c0,0.1,0.1,0.1,0.1,0.1h0.9l0.4,8.2c0,0.5,0.5,1,1,1h7.1\n\tc0.5,0,1-0.4,1-1l0.4-8.2h0.9C13.9,5.1,14,5.1,14,5V4.5C14,4.2,13.8,4,13.5,4z M11.4,13.1H4.6l-0.4-8h7.6L11.4,13.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol